// In alphabetical order! (A-Z)
export enum SidebarPages {
  AGREEMENTS = 'AGREEMENTS',
  AI = 'AI',
  API = 'API',
  ASSESSMENTS = 'ASSESSMENTS',
  BUDGET_APPROVALS = 'BUDGET_APPROVALS',
  BUDGETS = 'BUDGETS',
  CORE_DATA = 'CORE_DATA',
  CREATE_REQUEST = 'CREATE_REQUEST',
  DOCUMENTS = 'DOCUMENTS',
  DRAFTS = 'DRAFTS',
  FORMS = 'FORMS',
  HOME = 'HOME',
  INTEGRATIONS = 'INTEGRATIONS',
  NONE = 'NONE',
  OGR_USERS_AND_GROUPS = 'OGR_USERS_AND_GROUPS',
  PRODUCT_BRANDS = 'PRODUCT_BRANDS',
  PRODUCT_CATALOGUE = 'PRODUCT_CATALOGUE',
  PRODUCT_CATALOGUES = 'PRODUCT_CATALOGUES',
  RENEWALS = 'RENEWALS',
  REPORTING = 'REPORTING',
  REQUESTS = 'REQUESTS',
  RISK_ALERTS = 'RISK_ALERTS',
  RISK_MANAGEMENT = 'RISK_MANAGEMENT',
  RISKS = 'RISKS',
  RISK_SETTINGS = 'RISK_SETTINGS',
  SECURITY = 'SECURITY',
  SETTINGS_DASHBOARD = 'SETTINGS_DASHBOARD',
  SUBPROCESSORS = 'SUBPROCESSORS',
  SUPPLIERS = 'SUPPLIERS',
  TASKS = 'TASKS',
  USER_SETTINGS = 'USER_SETTINGS',
  USER_PROPERTIES = 'USER_PROPERTIES',
  WORKFLOW_LIST = 'WORKFLOW_LIST',
}
